import { UIHeading1, UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ModalHeader.css';

interface IModalHeaderProps {
  title?: string | null;
  sortSlot?: React.ReactNode;
  /** Крупный заголовок 18/24 - шторки листинга и мультипина по макету; без него заголовок 16/22 */
  hasLargeTitle?: boolean;
}

export const ModalHeader: React.FC<IModalHeaderProps> = ({ title, sortSlot, hasLargeTitle = false }) => {
  return (
    <div className={styles['header-content']}>
      {title &&
        (hasLargeTitle ? (
          <UIHeading3 as="h1">{title}</UIHeading3>
        ) : (
          <div className={styles['header-title']}>
            <UIHeading1 as="h1">{title}</UIHeading1>
          </div>
        ))}
      {sortSlot && <div className={styles['header-sort']}>{sortSlot}</div>}
    </div>
  );
};
